import { createFileRoute } from '@tanstack/react-router';
import { TransactionsView } from '@/features/transactions/components/TransactionsView';

export const Route = createFileRoute('/_authenticated/transacoes_/fixos')({ component: () => <TransactionsView lockedOrigin="fixo" /> });
